//Impuestos
export let IGV = 0.18;
export let ICBPER = 0.30;
export let IVAP = 0.04;

export let IGV_INCLUIDO = IGV + 1;

const DEFAULT_IMPUESTOS = {
    IGV: IGV,
    ICBPER,
    IVAP,
}

const fetchImpuestos = async () => {
    try {
        const req = await fetch('/api/config/impuestos/');

        if (!req.ok) {
            throw new Error(await req.text());
        }

        const impuestos = {}

        const data = await req.json()

        data.forEach((i) => {
            impuestos[i.Nombre] = i.Valor
        });

        return {...DEFAULT_IMPUESTOS, ...impuestos}
    } catch (e) {
        console.error(e);
    }

    return {...DEFAULT_IMPUESTOS}
}

export async function loadImpuestos() {
    const impuestos = await fetchImpuestos();

    IGV = impuestos.IGV;
    ICBPER = impuestos.ICBPER;
    IVAP = impuestos.IVAP;
}

//Tipos de PrecioPlantilla
export const PRECIO_COSTO = 1;
export const PRECIO_MENOR = 2;
export const PRECIO_MAYOR = 3;
export const PRECIO_VALE = 4;
export const PRECIO_FAMILIAR = 5;
export const PRECIO_ESPECIAL = 6;

//TIPOS COMPROBANTE
export const FACTURA = 2;
export const BOLETA = 4;
export const VALE = 1;
export const NOTA_DEBITO = 7;
export const NOTA_DE_CREDITO = 8;
export const NOTA_EGRESO = 53;
export const NOTA_INGRESO = 52;
export const ORDEN_COMPRA = 55;
export const GUIA_REMISION = 9;
export const GUIA_REMISION_TRANSPORTISTA = 31;

//TIPOS PAGO
export const EFECTIVO = 1;
export const MASTER = 2;
export const POS = 3;
export const AMERICAN = 4;
export const OTROS = 5;
export const PAGO_CREDITO = 6;
export const FPAY = 7;
export const TUNKI = 8;
export const PLIN = 9;
export const YAPE = 10;
export const RAPPI = 11;
export const PAGO_CONTADO = 12;
export const PEDIDO = 13;


export function getTiposPago() {
    return [EFECTIVO, MASTER, POS, AMERICAN, OTROS, PAGO_CREDITO, FPAY];
}

//MODALIDAD PAGO
export const CONTADO = 1;
export const CREDITO = 2;
export const MIXTO = 3;
export const OTRA_MODALIDAD_PAGO = 4;

//TIPO DOCUMENTO CLIENTE
export const RUC = 6;
export const DNI = 1;
export const CARNE_EXTRANJERIA = 4;
export const PASAPORTE = 7;
export const GENERICO = 99;
export const CEDULA_DIPLOMATICA_IDENTIDAD = 'A';

//PLAZOS DE CRÉDITOS
export const QUINCEDIAS = 1;
export const TREINTADIAS = 2;
export const CUARENTAYCINCODIAS = 3;
export const SESENTADIAS = 4;
export const NOVENTADIAS = 5;
export const CIENTOVEINTEDIAS = 6;
export const CIENTOCINCUENTADIAS = 7;
export const CIENTOOCHENTADIAS = 8;

//IdGrupoAfectacionIGV
export const GRAVADA = 1;
export const EXONERADA = 2;
export const INAFECTA = 3;
export const EXPORTACION = 4;

//Conversiones a Centimos
export const CENTIMOS_A_SOLES = 100;
export const SOLES_A_CENTIMOS = 100;

export const TIPO_MOV_CAJA = {
    SALIDA: "Salida",
    ENTRADA: "Entrada",
}

export const ESTADO_CE = {
    ACEPTADO: "Aceptado",
    ANULADO: "Anulado",
    PENDIENTE: "Pendiente",
    RECHAZADO: "Rechazado",
    NINGUNO: "",
}

export const TIPOS_DOC_SUNAT = {
    OTROS: -1
}

export const COD_TIPO_AFECTACION = {
    INAFECTO_BONIFICACION: '31',
    INAFECTO_ONEROSA: '30',
    EXONERADO_ONEROSA: '20',
    EXONERADO_GRATUITO: '21',
}

//TRIBUTOS
export const TRIBUTO = {
    IGV: 1,
    IVAP: 2,
    ISC: 3,
    ICBPER: 4,
    EXPORTACION: 5,
    GRATUITO: 6,
    EXONERADO: 7,
    INAFECTO: 8,
    OTROS: 9,
}

// Motivo de traslado para guia de remision

export const MOTIVO_TRASLADO = {
    ENTRE_ALMACENES: 6
}

//Ajuste de decimales -- documentacion: https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Math/floor
export const decimalAdjust = function (type, value, exp) {
    // Si el exp no está definido o es cero...
    if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Si el valor no es un número o el exp no es un entero...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
}

/** Redondeo decimal
 * Numero, numero de redondeo--- ejemplo round(15.33656, 2)
 * @param {Float} value
 * @param {Int} exp
 */
export const round = function (value, exp) {
    return decimalAdjust('round', value, -exp);
};
// Redondeo hacia abajo
export const floor = function (value, exp) {
    return decimalAdjust('floor', value, -exp);
};
// Redondeo hacia arriba
export const ceil = function (value, exp) {
    return decimalAdjust('ceil', value, -exp);
};
// Formatea una objeto tipo date
export const formatDate = (date, formatstring) => {
    switch (formatstring) {
        case 'dd-mm-yyyy':
            return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
        case 'yyyy-mm-dd': {
            const mes = date.getMonth() + 1;
            const dia = date.getDate();
            return `${date.getFullYear()}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`;
        }
        default:
            return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`
    }
}

export async function findPersonaNaturalByDni(dni) {
    let res = await fetch(`/api/clientes/dni/${dni}`);
    let data = await res.json();

    const nombreCompleto = data.name.trim();
    
    const partes = nombreCompleto.split(',');
    const partesApellidos = partes[0]?.trim() || '';
    const partesNombres = partes[1]?.trim() || '';
    
    const apellidosArray = partesApellidos.split(' ').filter(p => p.length > 0);
    
    const prefijosCompuestos = ['DE', 'DEL', 'DE LA', 'DE LOS', 'DE LAS',];
    
    let apellidoPaterno = '';
    let apellidoMaterno = '';
    
    if (apellidosArray.length >= 2) {
        if (prefijosCompuestos.includes(apellidosArray[0].toUpperCase())) {
            apellidoPaterno = apellidosArray.slice(0, 2).join(' ');
            apellidoMaterno = apellidosArray.slice(2).join(' ');
        } else {
            apellidoPaterno = apellidosArray[0];
            apellidoMaterno = apellidosArray.slice(1).join(' ');
        }
    } else if (apellidosArray.length === 1) {
        apellidoPaterno = apellidosArray[0];
    }
    
    const nombres = partesNombres.split(' ').filter(n => n.length > 0).join(' ');
    
    return {
        "nombres": nombres,
        "apPaterno": apellidoPaterno,
        "apMaterno": apellidoMaterno,
    };
}

export function calcularTotales3(items) {
    const gravados = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !i.Gratuito)
        .map(i => {
            return {...i, PrecioVenta: i.PrecioVenta / IGV_INCLUIDO}
        })
        .map(i => (i.PrecioVenta * i.Cantidad) - (i.Descuento / IGV_INCLUIDO))
        .reduce((a, b) => a + b, 0)

    const exonerados = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const inafectos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const gratuitos = items.filter(i => i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const icbper = items
        .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER))
        .map(i => i.Cantidad * 0.3)
        .reduce((a, b) => a + b, 0);

    const baseConIgv = (gravados * IGV_INCLUIDO)

    const total = baseConIgv + exonerados + inafectos + icbper;

    let totalForRound = total;

    if (!(Math.floor(total) === total) && total.toFixed(2) != total) {
        totalForRound = (Number(gravados.toFixed(2)) * IGV_INCLUIDO) + exonerados + inafectos + icbper;
    }

    const totalRedondeado = decimalAdjust('floor', totalForRound, -1);
    const redondeo = Math.abs((total - totalRedondeado).toFixed(12));

    return {
        gravados,
        exonerados,
        inafectos,
        gratuitos,
        icbper,
        total,
        totalRedondeado,
        redondeo
    }
}
// =============================================
// SISTEMA DE CALCULOS PARA VENTA GLOBAL
// =============================================

export function calcularTotales2(items, descuentoGlobal = 0) {
    // 1. Calcular TOTAL BRUTO (suma de todos los items en CENTIMOS)
    const totalBruto = items
        .map(i => parseFloat(i.Total) || 0)
        .reduce((a, b) => a + b, 0);

    // 2. Separar por tipos de afectación (en CENTIMOS)
    const exoneradosSoles = items
        .filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => parseFloat(i.Total) || 0)
        .reduce((a, b) => a + b, 0);

    const inafectosSoles = items
        .filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => parseFloat(i.Total) || 0)
        .reduce((a, b) => a + b, 0);

    const gratuitosSoles = items
        .filter(i => i.Gratuito)
        .map(i => parseFloat(i.Total) || 0)
        .reduce((a, b) => a + b, 0);

    // 3. Calcular ICBPER (en CENTIMOS - 0.30 soles por unidad = 30 céntimos)
    const icbperSoles = items
        .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER))
        .map(i => (parseFloat(i.Cantidad) || 0) * ICBPER)
        .reduce((a, b) => a + b, 0);

    // 4. Calcular SOLO LOS ITEMS GRAVADOS (que pagan IGV)
    const itemsGravados = items.filter(i => 
        i.IdGrupoClasificacionIgv === GRAVADA && 
        !i.Gratuito
    );
    
    const totalGravadoBruto = itemsGravados
        .map(i => parseFloat(i.Total) || 0)
        .reduce((a, b) => a + b, 0);

    // 5. CALCULAR BASE GRAVABLE E IGV (para items gravados en CENTIMOS)
    // Redondear a enteros ANTES de los cálculos para evitar decimales
    const gravada = Math.round(totalGravadoBruto / IGV_INCLUIDO);
    const igvVenta = totalGravadoBruto - gravada;

    // 6. Calcular TOTAL VENTA (suma de todos los conceptos en CENTIMOS)
    const totalVenta = gravada + 
                      igvVenta + 
                      exoneradosSoles + 
                      inafectosSoles + 
                      gratuitosSoles + 
                      icbperSoles;

    // Redondear todos los valores a enteros (en CENTIMOS)
    const gravadaRedondeada = Math.round(gravada);
    const igvVentaRedondeado = Math.round(igvVenta);
    const totalVentaRedondeado = Math.round(totalVenta);

    const redondeo = 0;

    console.log({
        'totalgrabados': gravadaRedondeada,
        'totalVentaRedondeado': totalVentaRedondeado,
        'totalIgv': igvVentaRedondeado
    });

    // CONVERSIÓN A SOLES (dividir entre 100)
    return {
        gravados: gravadaRedondeada, // 100,
        exonerados: exoneradosSoles, // 100,
        inafectos: inafectosSoles, // 100,
        gratuitos: gratuitosSoles, // 100,
        icbper: icbperSoles, // 100,
        igvVenta: igvVentaRedondeado, // 100,
        total: totalVentaRedondeado, // 100,
        totalRedondeado: totalVentaRedondeado, // 100,
        redondeo: redondeo // 100
    }
}
// =============================================
// SISTEMA DE CALCULOS POR ITEM EN CARRITO PARA VENTA GLOBAL
// =============================================

export function calcTotalPreventa(item, doDiscount = false) {
    const cantidad = Number(item.Cantidad);
    const precioVenta = Number(item.PrecioVenta);
    const descuento = doDiscount ? Number(item.Descuento || 0) : 0;
    
    let total = cantidad * precioVenta - descuento;
    
    return (total);
}


export const formatSoles = (priceInCents) => {
  return `${(priceInCents / 100)}`;
};


// export default function drPreventa(n) {
//     return Math.round(Number(n) * 100) / 100;
// }


// export function calcularTotales2(items,descuentoGlobal=0) {
//     // Función para convertir centimos a soles
//     const centimosToSoles = (centimos) => centimos / 100;

//     // 1. Calcular TOTAL (suma de todos los items en CENTIMOS)
//     const totalCentimos = items
//         .map(i => parseFloat(i.Total) || 0)
//         .reduce((a, b) => a + b, 0);

//     // Convertir a SOLES para todos los cálculos
//     const totalSoles = centimosToSoles(totalCentimos);

//     // 2. Separar por tipos de afectación (trabajar en SOLES)
//     const exoneradosSoles = items
//         .filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
//         .map(i => centimosToSoles(parseFloat(i.Total) || 0))
//         .reduce((a, b) => a + b, 0);

//     const inafectosSoles = items
//         .filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
//         .map(i => centimosToSoles(parseFloat(i.Total) || 0))
//         .reduce((a, b) => a + b, 0);

//     const gratuitosSoles = items
//         .filter(i => i.Gratuito)
//         .map(i => centimosToSoles(parseFloat(i.Total) || 0))
//         .reduce((a, b) => a + b, 0);

//     // 3. Calcular ICBPER (en SOLES - 0.30 soles por unidad)
//     const icbperSoles = items
//         .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER))
//         .map(i => (parseFloat(i.Cantidad) || 0) * ICBPER)
//         .reduce((a, b) => a + b, 0);

//     // 4. Calcular GRAVADA según tu fórmula
//     const gravadaSoles = totalSoles - exoneradosSoles - inafectosSoles - gratuitosSoles - icbperSoles;

//     // Aplicar redondeo solo a la gravada
//     const gravadaRedondeada = decimalAdjust('round', gravadaSoles, -2);

//     // 5. Calcular IGV
//     const igvVentaSoles = decimalAdjust('round', gravadaRedondeada * IGV, -2);

//     // 6. Calcular TOTAL VENTA (suma de todo)
//     const totalVentaSoles = gravadaRedondeada + 
//                            igvVentaSoles + 
//                            exoneradosSoles + 
//                            inafectosSoles + 
//                            gratuitosSoles + 
//                            icbperSoles;

//     // Redondeo final del total
//     const totalVentaRedondeado = decimalAdjust('round', totalVentaSoles, -2);
//     const redondeo = Math.abs(totalVentaSoles - totalVentaRedondeado);

//     return {
//         gravados: gravadaRedondeada,
//         exonerados: exoneradosSoles,
//         inafectos: inafectosSoles,
//         gratuitos: gratuitosSoles,
//         icbper: icbperSoles,
//         igvVenta: igvVentaSoles,
//         total: totalVentaRedondeado,
//         totalRedondeado: totalVentaRedondeado,
//         redondeo: redondeo
//     }
// }

export function calcularTotales(items) {
    console.log('=== calcularTotales INICIO ===');
    console.log('Items recibidos:', items);

    // 1. Calcular GRAVADA (base sin IGV) en céntimos
    const gravadosSinRedondear = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !i.Gratuito)
        .map(i => {
            // PrecioVenta está en céntimos, dividir por 1.18 para quitar IGV
            const precioSinIvaCentimos = i.PrecioVenta / IGV_INCLUIDO;
            const descuentoSinIvaCentimos = i.Descuento / IGV_INCLUIDO;
            return (precioSinIvaCentimos * i.Cantidad) - descuentoSinIvaCentimos;
        })
        .reduce((a, b) => a + b, 0);

    console.log('gravadosSinRedondear (con decimales):', gravadosSinRedondear);
    
    // Calcular el total con IGV (sin redondear la base)
    const totalConIgvSinRedondear = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !i.Gratuito)
        .map(i => (i.PrecioVenta * i.Cantidad) - (i.Descuento || 0))
        .reduce((a, b) => a + b, 0);
    
    console.log('totalConIgvSinRedondear:', totalConIgvSinRedondear);

    const totalConIgvRedondeado = Math.round(totalConIgvSinRedondear);
    console.log('totalConIgvRedondeado:', totalConIgvRedondeado);
    
    // REDONDEAR la base gravada a ENTEROS (en céntimos)
    const gravadosRedondeadosCentimos = Math.round(gravadosSinRedondear);
    console.log('gravadosRedondeadosCentimos (entero):', gravadosRedondeadosCentimos);
    
    // Calcular IGV como la diferencia (NO como base * IGV)
    const igvVentaCentimos = totalConIgvRedondeado - gravadosRedondeadosCentimos;
    console.log('igvVentaCentimos:', igvVentaCentimos);
    console.log('Verificación:', {
        'Base + IGV': gravadosRedondeadosCentimos + igvVentaCentimos,
        'Total original': totalConIgvRedondeado,
        'Coincide': (gravadosRedondeadosCentimos + igvVentaCentimos) === totalConIgvRedondeado
    });

    // 2. Calcular otros conceptos en céntimos
    const exoneradosCentimos = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const inafectosCentimos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const gratuitosCentimos = items.filter(i => i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    // ICBPER en céntimos
    const icbperCentimos = items
        .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || 
                    (i.Tributos && i.Tributos.includes(TRIBUTO.ICBPER)))
        .map(i => Math.round(i.Cantidad * 30))
        .reduce((a, b) => a + b, 0);

    // 3. Calcular TOTAL VENTA
    const totalGravadoConIgv = gravadosRedondeadosCentimos + igvVentaCentimos;
    const totalCentimos = totalGravadoConIgv + exoneradosCentimos + inafectosCentimos + icbperCentimos;
    
    const resultado = {
        gravados: gravadosRedondeadosCentimos,
        exonerados: exoneradosCentimos,
        inafectos: inafectosCentimos,
        gratuitos: gratuitosCentimos,
        icbper: icbperCentimos,
        igvVenta: igvVentaCentimos,
        total: totalCentimos,
        totalRedondeado: totalCentimos, // Ya está redondeado
        redondeo: 0,
        totalGravadoConIgv: totalGravadoConIgv
    };

    console.log('=== RESULTADO ===', {
        gravados: resultado.gravados,
        igvVenta: resultado.igvVenta,
        totalGravadoConIgv: resultado.totalGravadoConIgv,
        total: resultado.total,
        verificacion: {
            'Base + IGV': resultado.gravados + resultado.igvVenta,
            'Total final': resultado.total
        }
    });

    return resultado;
}

export function calcularTotalesDetMovAlmacen(items) {
    const gravados = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !i.Gratuito)
        .map(i => {
            return {...i, PrecioVenta: i.PrecioVenta / IGV_INCLUIDO}
        })
        .map(i => (i.PrecioVenta * i.Cantidad) - (i.Descuento / IGV_INCLUIDO))
        .reduce((a, b) => a + b, 0)

    const exonerados = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const fletes = items.map(i => getFlete(i) * i.Cantidad).reduce((a, b) => a + b, 0);

    const inafectos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const gratuitos = items.filter(i => i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const icbper = items
        .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER))
        .map(i => i.Cantidad * 0.3)
        .reduce((a, b) => a + b, 0);

    const baseConIgv = (gravados * IGV_INCLUIDO)

    const total = baseConIgv + exonerados + inafectos + icbper + fletes ;

    const totalRedondeado = decimalAdjust('floor', total, -1);
    const redondeo = Math.abs((total - totalRedondeado).toFixed(12));

    return {
        gravados,
        exonerados,
        inafectos,
        gratuitos,
        icbper,
        total,
        totalRedondeado,
        redondeo,
        fletes,
        baseConIgv
    }
}

function getFlete(item){
    if(!item.Flete || item.Flete == null || isNaN(item.Flete)){
        return 0;
    }
    return parseFloat(item.Flete)
}

export function calculateCotizaciones(items) {
    let esFree = (x) => x.Gratuito === "1" || x.Gratuito === 1 || x.Gratuito === true;
    console.log({items})
    const gravados = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !esFree(i))
        .map(i => {
            return {...i, precioVenta: dr(i.precioVenta / IGV_INCLUIDO), Descuento: i.Descuento? i.Descuento: 0}
        })
        .map(i => (i.precioVenta * i.cantidad) -(i.Descuento / IGV_INCLUIDO))
        .reduce((a, b) => a + b, 0)

    const descuento = items.map(i => i.Descuento).reduce((a, b) => a + b, 0);
    const exonerados = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA).map(i => i.total).reduce((a, b) => a + b, 0);
    const inafectos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA).map(i => i.total).reduce((a, b) => a + b, 0);
    const gratuitos = items.filter(i => esFree(i)).map(i => i.total).reduce((a, b) => a + b, 0);
    const icbper = items.filter(i => String(i.idAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER)).map(i => i.cantidad * 0.3).reduce((a, b) => a + b, 0);

    const baseConIgv = Number((gravados * IGV_INCLUIDO).toFixed(6))

    const total = baseConIgv + exonerados + inafectos + icbper;
    const totalRedondeado = decimalAdjust('floor', baseConIgv + exonerados + inafectos + icbper, -1);
    const redondeo = Math.abs(Number(total - totalRedondeado).toFixed(12));

    return {
        gravados,
        exonerados,
        inafectos,
        gratuitos,
        icbper,
        total,
        totalRedondeado,
        redondeo,
        descuento
    }
}
// =============================================
// NUEVO SISTEMA DE CALCULOS PARA COTIZACIONES GLOBAL
// =============================================
export function calculateCotizaciones2(items, descuentoGlobal = 0) {
    // Convertir ICBPER a centimos (0.30 soles = 30 centimos)
    const ICBPER_CENTIMOS = ICBPER * 100;

    // 1. Calcular TOTAL BRUTO (suma de todos los items en CENTIMOS)
    const totalBruto = items
        .map(i => Math.round(parseFloat(i.total)) || 0) // Redondear a entero
        .reduce((a, b) => a + b, 0);

    // 2. Separar por tipos de afectación (en CENTIMOS)
    const exoneradosCentimos = items
        .filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => Math.round(parseFloat(i.total)) || 0)
        .reduce((a, b) => a + b, 0);

    const inafectosCentimos = items
        .filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => Math.round(parseFloat(i.total)) || 0)
        .reduce((a, b) => a + b, 0);

    const gratuitosCentimos = items
        .filter(i => i.Gratuito)
        .map(i => Math.round(parseFloat(i.total)) || 0)
        .reduce((a, b) => a + b, 0);

    // 3. Calcular ICBPER (en CENTIMOS - 30 centimos por unidad)
    const icbperCentimos = items
        .filter(i => String(i.idAfectacionIgv) === AFECTACION_ICBPER_ID || 
                    (i.Tributos && i.Tributos.includes(TRIBUTO.ICBPER)))
        .map(i => (parseInt(i.cantidad) || 0) * ICBPER_CENTIMOS)
        .reduce((a, b) => a + b, 0);

    // 4. Calcular SOLO LOS ITEMS GRAVADOS (que pagan IGV)
    const itemsGravados = items.filter(i => 
        i.IdGrupoClasificacionIgv === GRAVADA && 
        !i.Gratuito
    );
    
    const totalGravadoBruto = itemsGravados
        .map(i => Math.round(parseFloat(i.total)) || 0)
        .reduce((a, b) => a + b, 0);

    // 5. CALCULAR BASE GRAVABLE E IGV para items gravados (en CENTIMOS)
    const gravada = Math.round(totalGravadoBruto / IGV_INCLUIDO);
    const igvVenta = totalGravadoBruto - gravada;

    // 6. Calcular TOTAL VENTA (suma de todos los conceptos en CENTIMOS)
    const totalVenta = gravada + 
                      igvVenta + 
                      exoneradosCentimos + 
                      inafectosCentimos + 
                      gratuitosCentimos + 
                      icbperCentimos;

    const redondeo = 0;

    console.log({
        'totalGravados': gravada,
        'totalVenta': totalVenta,
        'totalIgv': igvVenta
    });

    return {
        gravados: gravada,
        exonerados: exoneradosCentimos,
        inafectos: inafectosCentimos,
        gratuitos: gratuitosCentimos,
        icbper: icbperCentimos,
        igvVenta: igvVenta,
        total: totalVenta,
        totalRedondeado: totalVenta,
        redondeo: redondeo,
        descuento: descuentoGlobal
    };
}

export function calcTotal(item, doDiscount = false, attrCant = 'Cantidad', attrPv = 'PrecioVenta') {
    item[attrCant] = Number(item[attrCant])
    item[attrPv] = Number(item[attrPv])

    console.log('=== calcTotal INICIO ===', {
        cantidad: item[attrCant],
        precioVenta: item[attrPv],
        idGrupo: item.IdGrupoClasificacionIgv,
        doDiscount,
        descuento: item.Descuento
    });

    if (item.IdGrupoClasificacionIgv === EXONERADA || item.IdGrupoClasificacionIgv === INAFECTA) {
        const resultadoExonerado = item[attrCant] * item[attrPv];
        console.log('Producto EXONERADO/INAFECTO:', { resultadoExonerado });
        return resultadoExonerado;
    }

    const pv = (item[attrPv] / IGV_INCLUIDO)
    console.log('Precio sin IGV (pv):', { pv, IGV_INCLUIDO });

    const totalSinRedondeo = (pv * IGV_INCLUIDO * item[attrCant]) - (doDiscount ? item.Descuento : 0);
    console.log('Total sin redondeo:', { totalSinRedondeo });

    const resultado = Math.round(totalSinRedondeo);
    console.log('Total redondeado (Math):', { resultado });
    console.log('=== calcTotal FIN ===\n');

    return resultado;
}

export const NUMBER_KEYS = {
    THREE_NUMBER_KEY: 51
}

export const ESTADO_VENTA = {
    PROCESADA: "PROCESADA",
    ANULADA: "ANULADA",
};

export const ESTADO_VALE = {
    PENDIENTE: "PENDIENTE",
    PROCESADO: "PROCESADO",
    ANULADO: "ANULADO",
};

export const TIPO_STOCK = {
    CON_COMPROBANTE: 1,
    SIN_COMPROBANTE: 2,
    CON_COMPROBANTE_PREVENTA: 3,
    STOCK_COMPROMETIDO_VALE: 4,
    SIN_COMPROBANTE_PREVENTA: 5,
}

export const ESTADO_PREVENTA = {
    PROCESADA: "PROCESADA",
    CANCELADA: "CANCELADA",
    GENERADO: "GENERADO"
};

export function convertStrToJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
}

export const AFECTACION_ICBPER_ID = '19';

export const ID_TIPO_MOV_ALMACEN = {
    INGRESO: 1,
    SALIDA: 2
};

export const ID_TIPO_TRANSACCION = {
    ID_COMPRA_NACIONAL: 2,
    ID_BONIFICACION: 7,
    ID_RETIRO: 12,
    ID_TRANSFERENCIA_ENTRE_ALMACENES: 21
}

export default function dr(n, type = 'floor', places = 13, fix = 12) {
    return Number(Number(decimalAdjust(type, n, places * -1)).toFixed(fix));
}

export function doDownload(url, filename) {

    fetch(url).then(function (t) {
        return t.blob().then((b) => {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", filename);
                a.click();
            }
        );
    });
}

// =============================================
// SISTEMA DE FORMATEO GLOBAL
// =============================================
